<template>
  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting payroll entries...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <v-layout row align-center>
          <h1 class="display-1 mr-2">Pay Period:</h1>
          <template>
            <v-flex>
              <v-menu
                ref="startDateMenu"
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="Start Date"
                    format="dddd, MM DD YYYY"
                    @change="value => startDate = value"
                    :value="dateFormatted(startDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :show-current="endDate" v-model="startDate" @input="startDateMenu = false" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <template>
            <v-flex>
              <v-menu
                ref="endDateMenu"
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="End Date"
                    format="dddd, MM DD YYYY"
                    @change="value => endDate = value"
                    :value="dateFormatted(endDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :show-current="startDate" v-model="endDate" @input="endDateMenu = false" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <v-btn @click="reGetRecords" color="primary">
            Change Dates
          </v-btn>
        </v-layout>

        <v-layout row justify-center align-center class="text-xs-center mb-2">
          <v-flex>
            <v-pagination
              v-model="page"
              :length="pageLength"
            >
            </v-pagination>
          </v-flex>
        </v-layout>

        <v-layout row justify-end align-center class="mb-2">
          <v-flex shrink>
            <v-btn @click="csvExport" color="primary" :disabled="loadingCsv" :loading="loadingCsv">
              <v-icon left small>
                save_alt
              </v-icon>
              Export all pages
            </v-btn>
          </v-flex>
        </v-layout>

        <v-card>
          <v-card-title>
            <h1 class="subheading-1">Hourly Employees</h1>
          </v-card-title>

          <v-card-text>
            <div v-if="hasTotals(report)" v-for="report in hourlyEmployees" class="mb-5">
              <v-layout column>
                <v-flex class="mb-2">
                  <v-layout row @click="report.expanded = !report.expanded" class="report-row">
                    <v-flex xs2>
                      <h2 class="subheading font-weight-bold">{{ report.lastName }}, {{ report.firstName }}</h2>
                    </v-flex>
                    <v-flex>
                      <h2 class="d-inline-block subheading mr-2">Hours: {{ totalHours(report) }}, </h2>
                      <h2 class="d-inline-block subheading mr-2">Bonuses: {{ report.totalBonuses }},</h2>
                      <h2 class="d-inline-block subheading">Reimbursements: {{ report.totalReimbursements }}</h2>
                    </v-flex>


                    <v-flex class="text-xs-right">
                      <v-icon v-if="report.expanded">expand_less</v-icon>
                      <v-icon v-else>expand_more</v-icon>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                  <v-flex>
                    <h2 class="d-inline-block subheading mr-2">
                      First shift in report:
                      <router-link v-if="report.firstShift" :to="{ name: 'shiftDetail', params: { shiftId: report.firstShift.id } }" style="color: inherit;">{{ report.firstShift.start_datetime | moment("dddd, MMMM DD, h:mma") }} - {{  report.firstShift.end_datetime | moment("dddd, MMMM DD, h:mma") }}</router-link>
                      <span v-else>None (event hours only)</span>
                    </h2>
                    <h2 class="d-inline-block subheading mr-2">
                      Last shift in report:
                      <router-link v-if="report.lastShift" :to="{ name: 'shiftDetail', params: { shiftId: report.lastShift.id } }" style="color: inherit;">{{ report.lastShift.start_datetime | moment("dddd, MMMM DD, h:mma") }} - {{  report.lastShift.end_datetime | moment("dddd, MMMM DD, h:mma") }}</router-link>
                      <span v-else>None (event hours only)</span>
                    </h2>
                  </v-flex>
                  </v-layout>

                </v-flex>

                <v-flex class="mb-4" v-show="report.expanded">
                  <v-data-table
                    :items="report.report"
                    :headers="headers"
                    :pagination.sync="defaultSort"
                    hide-actions
                  >
                  <template slot="items" slot-scope="{ item }">
                    <tr v-if="hasAnyNonzero(item)">
                      <td>{{ item.name }}</td>
                      <td>{{ Math.round(item.hours * 100) / 100 }}</td>
                      <td>
                        <span v-if="item.name == 'Totals'">
                          {{ item.bonuses }}
                        </span>
                      </td>
                      <td>
                        <span v-if="item.name == 'Totals'">
                          {{ item.reimbursements }}
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>

        </v-card>
      </v-layout>

      <v-layout row justify-center align-center class="text-xs-center mt-4">
        <v-flex>
          <v-pagination
            v-model="page"
            :length="pageLength"
          >
          </v-pagination>
        </v-flex>
      </v-layout>

    </v-flex>
  </v-layout>
</template>

<script>
import ApiField from '@/components/base/api-field.vue'
import { mapState, mapGetters } from 'vuex'
import PunchRow from '@/components/calendar/punch.vue'
import { ExportToCsv } from 'export-to-csv';

export default {
  components: {
    PunchRow,
    ApiField,
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    ...mapGetters('timeclock', [
      'sortedPunches',
    ]),
    computedOffset: function () {
      return this.limit * (this.page - 1)
    },
    pageLength: function () {
      return Math.ceil(this.queryTotal / this.limit)
    },
    formattedQuery: function () {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
        limit: this.limit,
        offset: this.computedOffset,
        page: this.page,
      }
    },
  },
  created () {
    this.setUp()
  },
  watch: {
    'page': {
      handler(value) {
        if (value != this.$route.query.page) {
          this.reGetRecords()
        } else {
        }
      }
    }
  },
  data: function () {
    return {
      limit: 40,
      page: 1,
      startDateMenu: false,
      endDateMenu: false,
      startDate: this.$moment().subtract(2, "weeks").format('YYYY-MM-DD'),
      endDate: this.$moment().subtract(1, "weeks").format('YYYY-MM-DD'),
      reportsPending: true,
      loadingCsv: false,
      salariedEmployees: [],
      hourlyEmployees: [],
      defaultSort: {
        sortBy: 'order',
        rowsPerPage: -1, //all
      },
      headers: [
        { text: 'Shift Type', value: 'name', sortable: false },
        { text: 'Hours', value: 'hours', sortable: false },
        { text: 'Bonuses', value: null, sortable: false },
        { text: 'Reimbursements', value: null, sortable: false },
        { text: 'Notes', value: null, sortable: false },
      ],
    }
  },

  methods: {
    setUp: function () {
      this.startDate = this.$route.query.startDate || this.startDate
      this.endDate = this.$route.query.endDate || this.endDate
      this.page = parseInt(this.$route.query.page) || this.page

      this.$router.push({
        name: 'payrollReports',
        query: this.formattedQuery
      })

      this.getReports()
    },
    hasAnyNonzero: function (item) {
      if (item.hours > 0) {
        return true
      }
      return false
    },
    totalHours: function (employeeReport) {
      return Math.round(
        employeeReport.report.find(r => r.name == 'Totals')
          .hours * 100
        ) / 100
    },
    totalBonuses: function (employeeReport) {
      return Math.round(
        employeeReport.report.find(r => r.name == 'Bonuses')
          .hours * 100
        ) / 100
    },
    hasTotals: function (employeeReport) {
      if (this.totalHours(employeeReport) > 0) {
        return true
      }
      return false
    },

    generateCsv: function (data) {
      const options = { 
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true, 
        showTitle: false,
        filename: `payroll-report_${ this.$moment(this.startDate).format('YYYY-MM-DD') }--${ this.$moment(this.endDate).format('YYYY-MM-DD') }`,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
      };

      const exportedFormat = data.hourlyEmployees
        .filter(e => {
          if (this.totalHours(e) == 0) {
            return false
          }
          return true
        })
        .map(e => {
          e['Employee'] = `${ e.lastName }, ${ e.firstName }`
          delete e.lastName
          delete e.firstName
          delete e.displayName
          delete e.id

          e['Pay method'] = "Hourly"
          e['Salary'] = "?"
          let difs = e.report.map(d => {
            return {
              hours: this.round(d.hours) > 0 ? this.round(d.hours) : '',
              name: d.name
            }
          })
          delete e.report
          let base = difs.find(d => d.name == 'Base')
          let dif1 = difs.find(d => d.name == 'Dif 1')
          let dif2 = difs.find(d => d.name == 'Dif 2')
          let dif1PlusDif2 = dif1.hours + dif2.hours
          let dif3 = difs.find(d => d.name == 'Dif 3')
          let dif4 = difs.find(d => d.name == 'Dif 4')
          let dif5 = difs.find(d => d.name == 'Dif 5')
          let holiday_base = difs.find(d => d.name == 'Holiday Base')
          let holiday_dif1 = difs.find(d => d.name == 'Holiday Dif 1')
          let holiday_dif2 = difs.find(d => d.name == 'Holiday Dif 2')
          let holiday_dif3 = difs.find(d => d.name == 'Holiday Dif 3')
          let holiday_dif4 = difs.find(d => d.name == 'Holiday Dif 4')
          let holiday_dif5 = difs.find(d => d.name == 'Holiday Dif 5')
          let shiftOt = difs.find(d => d.name == 'ShiftOT')
          let weeklyOt = difs.find(d => d.name == 'WklyOT')
          let eventHours = difs.find(d => d.name == 'Event')
          e['Regular Pay Hrs'] = base.hours
          e['Weekend / swing Hrs'] = dif1PlusDif2
          e['Swing weekend Hrs'] = dif3.hours
          e['Overnight Hrs'] = dif4.hours
          e['Overnight weekend Hrs'] = dif5.hours
          e['Holiday swing weekday Hrs'] = holiday_dif1.hours
          e['Holiday swing weekend Hrs'] = holiday_dif3.hours
          e['Holiday overnight weekday Hrs'] = holiday_dif4.hours
          e['Holiday overnight weekend Hrs'] = holiday_dif5.hours
          e['OT Hrs'] = shiftOt.hours + weeklyOt.hours
          e['Holiday Pay Hrs'] = holiday_base.hours
          e['Holiday weekend day Hrs'] = holiday_dif2.hours
          e['Bonus'] = e.totalBonuses
          e['Event'] = eventHours.hours
          delete e.totalBonuses
          e['Reimbursement'] = e.totalReimbursements
          delete e.totalReimbursements
          e['First shift in report'] = e.firstShift
            ? `${ this.$moment(e.firstShift.start_datetime).format("dddd MMMM DD, h:mma") } - ${ this.$moment(e.firstShift.end_datetime).format("dddd MMMM DD, h:mma") }`
            : ''
          e['Last shift in report'] = e.lastShift
            ? `${ this.$moment(e.lastShift.start_datetime).format("dddd MMMM DD, h:mma") } - ${ this.$moment(e.lastShift.end_datetime).format("dddd MMMM DD, h:mma") }`
            : ''
          delete e.firstShift
          delete e.lastShift

          return e
        })

      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(exportedFormat);
      this.loadingCsv = false
    },

    round: function(hours) {
      return Math.round(hours * 100) / 100
    },

    csvExport: function () {
      this.loadingCsv = true
      this.$store.dispatch('reports/getPayrollReport', {
        startDate: this.startDate,
        endDate: this.endDate
      })
      .then(allEmployees => {
        this.generateCsv(allEmployees)
      }).catch(err => {
        console.log(err)
      }).finally(r => {
        this.loadingCsv = false
      })

    },
    dateFormatted: function (date) {
      return date ? this.$moment(date).format('dddd, MMMM D') : ''
    },
    getReports: function () {
      this.reportsPending = true
      this.$store.dispatch('reports/getPayrollReport', this.formattedQuery)
      .then(report => {
        this.queryTotal = report.total
        this.hourlyEmployees = report.hourlyEmployees.map(e => {
          let mapped = Object.assign({}, e)
          mapped.expanded = false
          return mapped
        })
        this.salariedEmployees = report.salariedEmployees
      }).catch(err => {
        console.log(err)
      }).finally(res => {
        this.reportsPending = false
      })
    },
    reGetRecords: function () {
      // Keep the URL in sync with the current page/date selection, then
      // actually reload the data. Previously this only pushed the route and
      // never re-fetched, so changing the page (or the dates) updated the URL
      // but left the report showing the first page's data — or, on a fresh
      // load of a deep page, spinning on "Getting payroll entries...".
      //
      // Do NOT chain .then/.catch on push(): router.js globally patches
      // VueRouter.prototype.push to swallow NavigationDuplicated and returns
      // undefined, so chaining would throw here before getReports() runs.
      this.$router.push({
        name: 'payrollReports',
        query: this.formattedQuery
      })
      this.getReports()
    },
  },
}
</script>

<style scoped>
  .report-row {
    cursor: pointer;
  }
  .report-row:hover {
    opacity: 0.6;
  }
</style>
